import { Observable } from 'rxjs';
import { CountryModel } from '../models/country.model';

export abstract class CountryRepository {
    abstract getAllContrys(): Observable<CountryModel[]>;
}
